import { ReactComponent as ActionIcon } from '@/assets/icons/screenplay/action.svg'
import { ReactComponent as CharacterIcon } from '@/assets/icons/screenplay/character.svg'
import { ReactComponent as DialogueIcon } from '@/assets/icons/screenplay/dialogue.svg'
import { ReactComponent as PageBreakIcon } from '@/assets/icons/screenplay/pagebreak.svg'
import { ReactComponent as ParansIcon } from '@/assets/icons/screenplay/parans.svg'
import { ReactComponent as SceneIcon } from '@/assets/icons/screenplay/scene.svg'
import { ReactComponent as ShotIcon } from '@/assets/icons/screenplay/shot.svg'
import { ReactComponent as TransitionIcon } from '@/assets/icons/screenplay/transition.svg'
import { Klass } from 'lexical'
import { FC, SVGProps } from 'react'
import { ActionNode } from './ActionNode'
import { BaseNode } from './BaseNode'
import { CharacterNode } from './CharacterNode'
import { DialogueNode } from './DialogueNode'
import { PageBreakNode } from './PageBreakNode'
import { ParansNode } from './ParansNode'
import { SceneNode } from './SceneNode'
import { ShotNode } from './ShotNode'
import { TransitionNode } from './TransitionNode'

import { NodeType } from './NodeType'

export { NodeType }

export type TNode = {
    shortcut: string[]
    label: string
    icon: FC<SVGProps<SVGSVGElement>>
    kClass: Klass<BaseNode>
    constructor: new (...args: any[]) => BaseNode
}
export const nodeRegistry: Record<NodeType, TNode> = {
    [NodeType.Scene]: {
        shortcut: ['ctrl', '1'],
        kClass: SceneNode,
        constructor: SceneNode,
        icon: SceneIcon,
        label: 'Scene',
    },
    [NodeType.Action]: {
        shortcut: ['ctrl', '2'],
        kClass: ActionNode,
        constructor: ActionNode,
        icon: ActionIcon,
        label: 'Action',
    },
    [NodeType.Character]: {
        shortcut: ['ctrl', '3'],
        kClass: CharacterNode,
        constructor: CharacterNode,
        icon: CharacterIcon,
        label: 'Character',
    },
    [NodeType.Parans]: {
        shortcut: ['ctrl', '4'],
        kClass: ParansNode,
        constructor: ParansNode,
        icon: ParansIcon,
        label: 'Parans',
    },
    [NodeType.Dialogue]: {
        shortcut: ['ctrl', '5'],
        kClass: DialogueNode,
        constructor: DialogueNode,
        icon: DialogueIcon,
        label: 'Dialogue',
    },
    [NodeType.Shot]: {
        shortcut: ['ctrl', '6'],
        kClass: ShotNode,
        constructor: ShotNode,
        icon: ShotIcon,
        label: 'Shot',
    },
    [NodeType.Transition]: {
        shortcut: ['ctrl', '7'],
        kClass: TransitionNode,
        constructor: TransitionNode,
        icon: TransitionIcon,
        label: 'Transition',
    },
    [NodeType.PageBreak]: {
        shortcut: ['ctrl', 'enter', '↵'],
        kClass: PageBreakNode,
        constructor: PageBreakNode,
        icon: PageBreakIcon,
        label: 'Page Break',
    },
}

export const lexicalNodes = Object.entries(nodeRegistry)
